/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-04-19 15:14:37
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-04-19 15:14:47
 * @FilePath: /dsicm-admin-web/src/utils/eventBus.js
 */
import Vue from 'vue'
export default new Vue()